// extracted by mini-css-extract-plugin
module.exports = {"grouping":"Grouping_grouping__3i_Vo"};